import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import base from "./modules/base";
import seller from "./modules/seller";
import receivables from "./modules/receivables";
import exchange from "./modules/exchange";
import investor from "./modules/investor";
import session from "@/store/modules/session";
import local from "@/store/modules/local";
import alfa from "@/store/modules/alfa";

const vuexSessionStorage = new VuexPersist({
    key: 'vuex',
    storage: window.sessionStorage,
    reducer: state => ({
        session: state.session
    })
});

const vuexLocalStorage = new VuexPersist({
    key: 'vuex',
    storage: window.localStorage,
    reducer: state => ({
        local: state.local
    })
});

Vue.use(Vuex);
const store = new Vuex.Store({
    modules: {
        base,
        seller,
        receivables,
        exchange,
        alfa,
        investor,
        session,
        local
    },
    plugins: [vuexSessionStorage.plugin, vuexLocalStorage.plugin]
});
export default store;